var __jsx = React.createElement;
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import LoginBlock from './LoginBlock';
import SignupForm from './SignupForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons/faUserCircle';
import styles from '../styles/login/LoginForm.module.css';

var ConnectBlock = function ConnectBlock(props) {
  var onboard = props.onboard,
      email = props.email;

  var _useState = useState(onboard),
      key = _useState[0],
      setKey = _useState[1];

  var changeActiveTab = function changeActiveTab(e) {
    setKey(e);
  };

  var tabs = __jsx(Row, {
    className: "justify-content-center py-0 no-gutters"
  }, __jsx(Col, {
    xs: "12",
    sm: "8",
    lg: "10"
  }, __jsx(Tabs, {
    activeKey: key,
    onSelect: changeActiveTab
  }, __jsx(Tab, {
    eventKey: "login",
    title: "Login",
    tabClassName: "w-50 text-center"
  }), __jsx(Tab, {
    eventKey: "signup",
    title: "Creeaza cont",
    tabClassName: "w-50 text-center"
  }))));

  var userForm = key == "login" ? __jsx(Row, {
    className: "justify-content-center m-0 "
  }, __jsx(LoginBlock, {
    xs: "12",
    sm: "8",
    lg: "10",
    redirectUrl: false,
    openAccountLink: false,
    defaultEmail: email
  })) : __jsx(Row, {
    className: "justify-content-center py-0 m-0"
  }, __jsx(Col, {
    xs: "12",
    sm: "8",
    lg: "10",
    className: "bg-white p-5 ".concat(styles.frameBorder)
  }, __jsx("h1", {
    className: "heading2 black-text text-center"
  }, "Creeaza un cont nou"), __jsx("p", {
    className: "text-center red"
  }, __jsx(FontAwesomeIcon, {
    icon: faUserCircle,
    height: 60,
    width: 60,
    size: "5x"
  })), __jsx(SignupForm, {
    redirectUrl: false,
    loginLink: false,
    defaultEmail: email
  })));
  return __jsx("section", null, tabs, userForm);
};

export default ConnectBlock;